import type { PropsWithChildren } from 'react'
import { Provider } from 'react-redux'
import { AuthBootstrap } from '@/platform/auth/ui/AuthBootstrap'
import { store } from '@/app/store/store'
import { CheckpointLifecycle } from '@/platform/lifecycle/CheckpointLifecycle'
import { ReferralCapture } from '@/platform/referrals/ui/ReferralCapture'

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <Provider store={store}>
      <AuthBootstrap />
      <ReferralCapture />
      <CheckpointLifecycle />
      {children}
    </Provider>
  )
}
